// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___11Tb1","label":"Editor__label___1mmqH","input":"Editor__input___28IAs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/InputText/Editor/Editor.scss
// module id = 988
// module chunks = 0